/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from 'react';
import { Optional } from '@steelbuy/ts-shared';
import { AccessToken, JsonWebToken, RefreshToken } from '../jwt/JsonWebToken';

export interface AuthContextValue {
    authenticate(accessToken: AccessToken, refreshToken: RefreshToken): void;

    update(accessToken: AccessToken): void;

    reauthenticate(): void;

    unauthenticate(queryParam?: string): void;

    getToken(): Optional<JsonWebToken>;

    isAuthenticated(): boolean;

    needsUpdate(): boolean;

    hasPermission(permission: string): boolean;

    setIsFetchingToken: (isFetching: boolean) => void;

    getIsFetchingToken: () => boolean;

    waitForToken: () => Promise<void>;
}

// noinspection JSUnusedLocalSymbols
export const AuthContext = createContext<AuthContextValue>({
    authenticate: (accessToken: AccessToken, _refreshToken: RefreshToken): void => {},
    update: (accessToken: AccessToken): void => {},
    reauthenticate: (): void => {},
    unauthenticate: (queryParam: string): void => {},
    getToken: (): Optional<JsonWebToken> => new Optional<JsonWebToken>(null),
    isAuthenticated: (): boolean => false,
    needsUpdate: (): boolean => false,
    hasPermission: (permission: string): boolean => false,
    setIsFetchingToken: (isFetching: boolean) => null,
    getIsFetchingToken: () => false,
    waitForToken: () => Promise.resolve(),
});
